import { customInstanceForCsv } from '@fukuri-admins/apis/client/base/axiosInstance';
import type { Key } from 'swr';
import { useMutation } from '../useMutation';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
};

/**
 * CSV（Blob）ダウンロード用の任意発火 hook。
 * `customInstanceForCsv` を `useMutation` でラップし、`trigger()` で 1 回限りの取得を行う。
 *
 * CSV ダウンロードはボタンクリック時に 1 回だけ実行・キャッシュ不要のため、
 * HTTP method が GET であっても「任意発火」として `useMutation` を使う。
 * （Orval が MutationKey factory を生成しない Orval 非対応エンドポイントのため
 *   `['downloadCsv', url]` の独自キーを許容している）
 *
 * @param url - CSV エンドポイントの URL（`.csv` 拡張子付き）
 * @param options - 成功時 / 失敗時コールバック
 */
export const useDownloadCsv = (url: string, options?: Options) =>
  useMutation(
    ['downloadCsv', url] as Key,
    (_: Key) => customInstanceForCsv({ url, method: 'GET' }),
    options
  );
